import React from 'react';
import {  Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import ReduxFormInput from '../../../../shared/components/ReduxFormHandlers/ReduxFormInput';
import * as validate from '../../../../helpers/validation.helper';
import LoaderButton from '../../../../shared/components/Button/LoaderButton';
import IState from '../../../../core/models/IState';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

const ChangePasswordForm: React.FC<any> = (props: any) => {

  const validateConfirmPassword = (message: string) => (value: string, allValues: any) => {
    if (value !== "" && value !== allValues.NewPassword)
      return message;
  }

  return (
    
      <form onSubmit={props.handleSubmit((values: any) => props.onSubmitForm(values))} noValidate>        
          {!props.isAdmin && <div className="modal-body py-0"><div className="form-group">
            <label className="label-style">
              <FormattedMessage id='ChangePassword_Label_Current_Password' />
            </label>
            <div className="input-group">
              <Field
                className="form-control"
                name="CurrentPassword"
                component={ReduxFormInput}
                type="password"
                min={6}
                max={20}
                validate={[
                  validate.validateRequired("Validation_Required_Current_Password"),
                  validate.validatePassword,
                  validate.validateMinLength(6, 'User_Validation_Password_Min_Char'),
                  validate.validateMaxLength(20, 'User_Validation_Password_Max_Char'),
                ]}
              />
            </div>
          </div>
          </div>
          }
          <div className="modal-body pt-0">
          <div className="form-group">
            <label className="label-style"><FormattedMessage id='Label_New_Password' /> </label>
            <div className="input-group">
              <Field
                className="form-control"
                name="NewPassword"
                component={ReduxFormInput}
                type="password"
                min={6}
                max={20}
                validate={[
                  validate.validateRequired("ChangePassword_Validation_New_Required_Password"),
                  validate.validatePassword,
                  validate.validateMinLength(6, 'User_Validation_Password_Min_Char'),
                  validate.validateMaxLength(20, 'User_Validation_Password_Max_Char'),

                ]}
              />
            </div>
          </div>
          <div className="form-group">
            <label className="label-style"><FormattedMessage id='Label_ConfirmPassword' /> </label>
            <div className="input-group">
              <Field
                className="form-control"
                name="ConfirmPassword"
                component={ReduxFormInput}
                type="password"
                min={6}
                max={20}
                validate={[validate.validateRequired("Validation_Required_Confirm_Password"),
                validateConfirmPassword("Validation_New_Confirm_Password_Mismatch")
                ]}
              />
            </div>
          </div>
          </div>
          <div className="modal-footer">
            {/* <Button variant="primary" onClick={props.onModalClosed} className="btnOkSize mr-2"><FormattedMessage id='Button_Cancel' /></Button> */}
            <LoaderButton type="submit" isLoading={props.loading} text="Button_Save" />
          </div>
      </form>
  );
};

const selector = formValueSelector('ChangePasswordForm');

const mapStateToProps = (state: IState) => ({
  newPasswordSelector: selector(state, 'NewPassword'),
});

const form = reduxForm<any, any>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  form: 'ChangePasswordForm'
})(ChangePasswordForm)

export default connect(mapStateToProps)(form);